import { useToggle } from 'react-use';

import { commonTranslationKeys } from '@dreryk/react-common';
import { EditIcon, IconFillColor, IconWrapper, Tooltip } from '@dreryk/react-components';

import { HealthcarePracticeFormBean } from '../common/healthcarePractice';
import { ServiceProvidingLocationFormBean } from '../common/serviceProvidingLocation';

import { ServiceProvidingLocationUpdateModal } from './ServiceProvidingLocationUpdateModal';

type ServiceProvidingLocationUpdateLinkProps = {
   readonly onUpdate: (formData: ServiceProvidingLocationFormBean) => Promise<unknown> | void;
   readonly prepareInitialData: () => Promise<ServiceProvidingLocationFormBean>;
   readonly healthcarePractice: HealthcarePracticeFormBean;
};

export const ServiceProvidingLocationUpdateLink = (props: ServiceProvidingLocationUpdateLinkProps): JSX.Element => {
   const [showUpdateModal, toggleShowUpdateModal] = useToggle(false);

   const onUpdate = async (formData: ServiceProvidingLocationFormBean): Promise<void> => {
      await props.onUpdate(formData);
      toggleShowUpdateModal();
   };

   return (
      <>
         <Tooltip content={commonTranslationKeys.edit} testId={'showUpdateModal'}>
            <IconWrapper onClick={toggleShowUpdateModal} fillColor={IconFillColor.PRIMARY} testId={'showUpdateModal'}>
               <EditIcon />
            </IconWrapper>
         </Tooltip>
         {showUpdateModal ? (
            <ServiceProvidingLocationUpdateModal
               healthcarePractice={props.healthcarePractice}
               prepareInitialData={props.prepareInitialData}
               onClose={toggleShowUpdateModal}
               onUpdate={onUpdate}
            />
         ) : null}
      </>
   );
};
